import style from "./Header.module.scss";

export default function Header() {
    return (
        <header className={style.root}>
            <div className={style.logo}></div>
        </header>
    );
}
